import {useEffect, useState} from "react";
import {baseUrl} from "../utils/webInfo";
import {catchError} from "../utils/helper";

const useStore = () => {
    const [user, setUser] = useState<any>(null);
    const [isLoading, setLoading] = useState(true);
    const [accessToken, setAccessToken] = useState<any>(null)


    useEffect(() => {
        const refresh = async () => {

            try {
                const res = await fetch(`${baseUrl.url}/auth/refresh`, {
                    method: "GET",
                    credentials: "include",
                });
                if (res.ok){
                    const resData = await res.json();
                    setAccessToken(resData?.data.token);
                }

                    // setAccessToken("THE TOKEN");
                    setUser({
                        id: 1,
                        name: "Admin User",
                        email: "admin@example.com",
                        role: "admin",
                        permissions: ["all"]
                    })
            } catch (error) {
                catchError(error);
            }finally {
                setLoading(false);
            }
        };
        if (!accessToken) {
            refresh();
        }

        const interval = setInterval(refresh, 14 * 60 * 1000);
        return () => clearInterval(interval);
    }, [accessToken]);

    return {
        user,
        isLoading,
        setLoading,
        setUser,
        accessToken,
        setAccessToken,
    };
};

export default useStore;